import styled from 'styled-components';

export const StyledMetaverseSection = styled.div`
  width: 100%;
  margin-bottom: 1rem;

  .metaverse-section-items {
    padding: 2rem 1.5rem;
    width: 100%;
    row-gap: 2.5rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: start;
  }

  .metaverse-section-title-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 0;
    height: 26px;
    gap: 2px;
  }

  .metaverse-section-title-stub-short {
    background: ${({ theme }) => theme.menuTitle};
    width: 20px;
    min-width: 20px;
    height: 100%;
  }

  .metaverse-section-title-stub-long {
    background: ${({ theme }) => theme.menuTitle};
    width: 100%;
    height: 100%;
  }

  .metaverse-section-title {
    text-transform: uppercase;
    height: 100%;
    padding: 0 6px;
    font-family: "BebasNeue";
    font-size: 2em;
    font-weight: 500;
    color: white;
    line-height: 1;
    white-space: nowrap;
  }

  .metaverse-section-page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    padding: 20px;
  }

  .metaverse-section-carousel-wrapper {
    height: 17.5rem;
    overflow: hidden;
  }

  .metaverse-section-title-button {
    height: 30px;
    width: 30px;
    padding: ${({ theme }) => theme.buttonFrameWidth};
    position: relative;

    .metaverse-section-title-button-corner {
      position: absolute;
      border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'transparent'};
      top: 0;
      bottom: 0;
      width: 8px
    }

    .metaverse-section-title-button-corner-l {
      border-right: none;
      left: 0;
    }

    .metaverse-section-title-button-corner-r {
      border-left: none;
      right: 0;
    }

    &:hover {
      .metaverse-section-title-button-corner {
        border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
      }

      .metaverse-section-title-button-corner-l {
        border-right: none;
      }

      .metaverse-section-title-button-corner-r {
        border-left: none;
      }
    }
  }

  .metaverse-section-title-button-content {
    width: 100%;
    height: 100%;
    padding: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.menuTitle};
  }

  .metaverse-section-title-controls {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
`;

